import nl2br from "react-nl2br";
export var getTooltipText = function (tooltips, actualKey, actualSeparator) {
    if (actualSeparator === void 0) { actualSeparator = null; }
    if (tooltips === null || tooltips === undefined) {
        return false;
    }
    var selectedTooltip = false;
    if (actualSeparator != null) {
        selectedTooltip = tooltips.find(function (_a) {
            var key = _a.key, separator = _a.separator;
            return key === actualKey && (separator === actualSeparator || separator === "" || separator === undefined || separator == null);
        });
    }
    else {
        selectedTooltip = tooltips.find(function (_a) {
            var key = _a.key;
            return key === actualKey;
        });
    }
    if (!selectedTooltip) {
        return false;
    }
    var text = nl2br(selectedTooltip['text']);
    return text;
};
